/*
 * Copyright (c) by INFODATA-GROUP. All rights reserved.
 * No part of this publication may be reproduced, distributed,
 * or transmitted in any form or by any means, including photocopying, recording,
 * or other electronic or mechanical methods, without the prior written permission of the publisher,
 * except in the case of brief quotations embodied in critical
 * reviews and certain other noncommercial uses permitted by copyright law.
 *  author : vhe
 *  date : 02/03/2021 07:39
 */

import { CommonUtils } from '../../tool/common-utils';

export class HighlightLegend {
  public name: string;
  public backgroundColor: string;
  public borderColor: string;
  public color: string;
  public type: 'full' | 'dot';
  public angle: 'TR' | 'BL' = 'TR';
  constructor(
    name: string,
    backgroundColor: string,
    color?: string,
    borderColor?: string,
  ) {
    this.name = name;
    this.backgroundColor = backgroundColor;
    this.borderColor = borderColor ? borderColor : backgroundColor;
    this.color = color ? color : CommonUtils.color('black');
    this.type = 'full';
  }
}
